import React from 'react';
import '../../assets/css/common/pageLoader.scss';

const Index = () => {
    return (
        <div className="clear-loader d-flex align-items-center justify-content-center">
            <div className="loader-circle"></div>
            <div className="loader-text text-black">
                <div>
                    <span className="text-theme">CB</span>
                    <span>MS</span>
                </div>
            </div>
        </div>
    );
};

export default Index;
